import TOTPCodeInputFormPage from './TOTPCodeInputForm.page';
export default TOTPCodeInputFormPage;
